import { reactive } from 'vue'

export function useUnitCheckboxStates() {
    // Estado reactivo para los checkboxes por unidad
    const unitCheckboxStates = reactive<
        Record<
            string,
            {
                seguir: boolean
                missionPlan: boolean
                events: boolean
                showTrack: boolean
            }
        >
    >({})

    // Función para inicializar el estado de una unidad si no existe
    const initializeUnitState = (unitId: string) => {
        if (!unitCheckboxStates[unitId]) {
            unitCheckboxStates[unitId] = {
                seguir: false,
                missionPlan: false,
                events: false,
                showTrack: false
            }
        }
    }

    // Función para obtener el estado de un checkbox específico
    const getCheckboxState = (
        unitId: string,
        checkboxType: keyof (typeof unitCheckboxStates)[string]
    ): boolean => {
        initializeUnitState(unitId)
        return unitCheckboxStates[unitId][checkboxType]
    }

    // Función para actualizar el estado de un checkbox
    const setCheckboxState = (
        unitId: string,
        checkboxType: keyof (typeof unitCheckboxStates)[string],
        value: boolean
    ) => {
        initializeUnitState(unitId)
        unitCheckboxStates[unitId][checkboxType] = value
    }

    return {
        unitCheckboxStates,
        initializeUnitState,
        getCheckboxState,
        setCheckboxState
    }
}
